import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();


// export const pageState = atom({ // components/DataTable/atom
//     key: "pageState",
//     default: 1,
// });

// export const groupListState = atom({  // components/Form/atom
//     key: "groupListState",
//     default: [],
// });

// export const comboListState = atom({  // components/Form/atom
//     key: "comboListState",
//     default: [],
// });

// export const levelListState = atom({  // components/Form/atom
//     key: "levelListState",
//     default: [],
// });

// export const popupUserListState = atom({  // components/Form/atom
//     key: "popupUserListState",
//     default: [],
// });

// export const navbarState = atom({  // components/Navbar/atom
//     key: "navbarState",
//     default: {},
// });

// export const userGroupState = atom({  // pages/Login/atom
//     key: "userGroupState",
//     default: "",
// });

// export const userLevelState = atom({  // pages/Login/atom
//     key: "userLevelState",
//     default: "",
// });

// export const userState = atom({  // pages/Login/atom
//     key: "userState",
//     default: false,
//     effects_UNSTABLE: [persistAtom],
// });

// export const currentBsdState = atom({  // pages/SMS/ItemSetting/atom
//     key: "currentBsdState", // 상태의 고유한 키
//     default: null,  // 초기값
//     effects_UNSTABLE: [persistAtom],
// });

export const bsdNmState = atom({  // pages/SMS/ItemSetting/atom
    key: "bsdNmState", // 상태의 고유한 키
    default: '',  // 초기값
    effects_UNSTABLE: [persistAtom],
});

export const authCodeState = atom({  // pages/SMS/ItemSetting/atom
    key: "authCodeState", // 상태의 고유한 키
    default: '',  // 초기값
    effects_UNSTABLE: [persistAtom],
});

export const generatedCodeState = atom({  // pages/SMS/ItemSetting/atom
    key: "generatedCodeState", // 상태의 고유한 키
    default: '',  // 초기값
    effects_UNSTABLE: [persistAtom],
});

export const bsdListState = atom({  // pages/SMS/ItemSetting/atom
    key: "bsdListState", // 상태의 고유한 키
    default: [],  // 초기값
    effects_UNSTABLE: [persistAtom],
});

export const currentBsdListState = atom({  // pages/SMS/ItemSetting/atom
    key: "currentBsdListState", // 상태의 고유한 키
    default: null,  // 초기값
    effects_UNSTABLE: [persistAtom],
});

export const registedAlarmSetListState = atom({  // pages/SMS/ItemSetting/atom
    key: "registedAlarmSetListState",
    default: null,
    effects_UNSTABLE: [persistAtom],
});

export const smsItemUserState = atom({  // pages/SMS/ItemSetting/atom
    key: "smsItemUserState",
    default: null,
    effects_UNSTABLE: [persistAtom],
});

export const smsReceiveUserState = atom({  // pages/SMS/ReceiveSetting/atom
    key: "smsReceiveUserState",
    default: null,
    effects_UNSTABLE: [persistAtom],
});

export const smsReceiveTelNoState = atom({
    key: "smsReceiveTelNoState",
    default: null,
    effects_UNSTABLE: [persistAtom],
  });
